module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n   " + _vm._s(_vm.actionToBePerformed) + "\n  ")]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_vm._m(0), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/customer-list"
    }
  }, [_vm._v("Back")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Add / Update Customer")])])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12 col-lg-12"
  }, [_c('form', {
    attrs: {
      "action": "#",
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.addOrUpdateOrDeleteCustomer.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Customer Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gRowObj.name),
      expression: "gRowObj.name"
    }],
    staticClass: "form-control",
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.gRowObj.name.required
    },
    attrs: {
      "type": "text",
      "id": "name",
      "placeholder": "Customer Name"
    },
    domProps: {
      "value": (_vm.gRowObj.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.gRowObj, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.submitted && !_vm.$v.gRowObj.name.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please enter customer name.")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Country")]), _vm._v(" "), _c('nv-select', {
    staticClass: "form-control",
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.gRowObj.country_id.required
    },
    attrs: {
      "id": "country_id"
    },
    model: {
      value: (_vm.gRowObj.country_id),
      callback: function($$v) {
        _vm.$set(_vm.gRowObj, "country_id", $$v)
      },
      expression: "gRowObj.country_id"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Choose a Country--")]), _vm._v(" "), _vm._l((_vm.countryList), function(data, index) {
    return _c('option', {
      key: index,
      domProps: {
        "selected": data.country_id === _vm.gRowObj.country_id,
        "value": data.country_id
      }
    }, [_vm._v(_vm._s(data.country_name))])
  })], 2), _vm._v(" "), (_vm.submitted && !_vm.$v.gRowObj.country_id.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please choose an country.")]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Contract")]), _vm._v(" "), _c('nv-select', {
    staticClass: "form-control",
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.gRowObj.contract_status.required
    },
    attrs: {
      "id": "contract_status"
    },
    model: {
      value: (_vm.gRowObj.contract_status),
      callback: function($$v) {
        _vm.$set(_vm.gRowObj, "contract_status", $$v)
      },
      expression: "gRowObj.contract_status"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Choose a Contract--")]), _vm._v(" "), _vm._l((_vm.customerContractList), function(data) {
    return _c('option', {
      key: data.value,
      domProps: {
        "selected": data.value === _vm.gRowObj.contract_status,
        "value": data.value
      }
    }, [_vm._v(_vm._s(data.name))])
  })], 2), _vm._v(" "), (_vm.submitted && !_vm.$v.gRowObj.contract_status.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please choose a contract.")]) : _vm._e()], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "type"
    }
  }, [_vm._v("Conversation")]), _vm._v(" "), _c('treeselect', {
    attrs: {
      "placeholder": "--Choose a conversation--",
      "multiple": false,
      "options": _vm.conversationList
    },
    model: {
      value: (_vm.gRowObj.conversation_id),
      callback: function($$v) {
        _vm.$set(_vm.gRowObj, "conversation_id", $$v)
      },
      expression: "gRowObj.conversation_id"
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-4 col-sm-4 col-md-4 col-lg-4"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("Action")]), _vm._v(" "), _c('nv-select', {
    staticClass: "form-control",
    class: {
      'form-group--error': _vm.frmAddRemoveMethodSubmitted && !_vm.$v.methodObj.methodAction.required
    },
    model: {
      value: (_vm.methodObj.methodAction),
      callback: function($$v) {
        _vm.$set(_vm.methodObj, "methodAction", $$v)
      },
      expression: "methodObj.methodAction"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select Action--")]), _vm._v(" "), _vm._l((_vm.methodActionList), function(data, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": data.id,
        "selected": data.id === _vm.methodObj.methodAction
      }
    }, [_vm._v(_vm._s(data.value))])
  })], 2), _vm._v(" "), (_vm.frmAddRemoveMethodSubmitted && !_vm.$v.methodObj.methodAction.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please select method action.")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("Methods")]), _vm._v(" "), _c('nv-select', {
    staticClass: "form-control",
    class: {
      'form-group--error': _vm.frmAddRemoveMethodSubmitted && !_vm.$v.methodObj.choosenMethods.required
    },
    attrs: {
      "multiple": ""
    },
    model: {
      value: (_vm.methodObj.choosenMethods),
      callback: function($$v) {
        _vm.$set(_vm.methodObj, "choosenMethods", $$v)
      },
      expression: "methodObj.choosenMethods"
    }
  }, _vm._l((_vm.servicesList), function(value, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": value.id
      }
    }, [_vm._v(_vm._s(value.legacy_name + ' [' + value.altName + ']'))])
  }), 0), _vm._v(" "), (_vm.frmAddRemoveMethodSubmitted && !_vm.$v.methodObj.choosenMethods.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please select method.")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-2 col-sm-2 col-md-2 padding-top-15px"
  }, [_c('i', {
    staticClass: "fa fa-plus-circle add-property",
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.addOrRemoveMethod()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12 padding-top-15px"
  }, [_c('div', {
    staticClass: "form-group col-xs-12 col-sm-12 col-md-12"
  }, [(Object.keys(_vm.gRowObj.methods).length) ? _c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(4), _vm._v(" "), _vm._l((_vm.gRowObj.methods), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v(_vm._s(item.methodAction))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "60%"
      }
    }, _vm._l((item.choosenMethodsNames), function(element, index) {
      return _c('span', {
        key: index
      }, [_c('button', {
        staticClass: "btn btn-outline-secondary btn-sm",
        staticStyle: {
          "margin": "2px"
        },
        attrs: {
          "type": "button"
        }
      }, [_vm._v(_vm._s(element))])])
    }), 0), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          return _vm.editMethod(item, index)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_c('i', {
      staticClass: "fa fa-times-circle",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          return _vm.deleteMethod(item, index)
        }
      }
    })])])
  })], 2) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "action-button"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('input', {
    staticClass: "btn btn-primary margin-left-20px",
    attrs: {
      "type": "submit",
      "value": "Submit"
    }
  })])])])])])])])])]), _vm._v(" "), (_vm.loading) ? _c('BlockUI', [_c('i', {
    staticClass: "fa fa-cog fa-spin fa-3x fa-fw"
  }), _c('br'), _vm._v("Please wait...")]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" Home")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Customer Configuration")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Preferred Default Conversation")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Methods Removal")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "thead-dark"
  }, [_c('tr', [_c('th', [_vm._v("Action")]), _vm._v(" "), _c('th', [_vm._v("Method")]), _vm._v(" "), _c('th', [_vm._v("Edit")]), _vm._v(" "), _c('th', [_vm._v("Delete")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-4c9324f4","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/customer-management/addOrUpdateCustomer.vue
// module id = qm25
// module chunks = 1